import { forwardRef, type InputHTMLAttributes } from "react";
import cx from "clsx";

export type RadioButtonProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "type"
>;

export const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(
  ({ className, ...props }, ref) => {
    return (
      <div className={cx("radio-wrapper", className)}>
        <input
          {...props}
          type="radio"
          className="radio-button-input"
          ref={ref}
        />
          <div
          className={`radio-checkedMark-before ${
            props.checked === true ? "radio-checked-after" : ""
          }`}
        ></div>
      </div>
    );
  },
);

RadioButton.displayName = "RadioButton";
